import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  CreateUpdateDisputeIssueBaseDto,
  DisputeCaseBaseDto,
  DisputeIssueBaseDto,
} from "src/app/shared/models/dispute-resolution/dispute-base-models";
import { AddEditIssueComponent } from "../add-edit-issue/add-edit-issue.component";
import { Subscription } from "rxjs";

@Component({
  selector: "app-issues-list",
  templateUrl: "./issues-list.component.html",
  styleUrls: ["./issues-list.component.scss"],
  standalone: false,
})
export class IssuesListComponent implements OnInit, OnDestroy {
  @Input() disputeCase: DisputeCaseBaseDto;
  @Input() issues: CreateUpdateDisputeIssueBaseDto[] = [];
  @Input() title: string;
  @Output() issuesChange = new EventEmitter<
    CreateUpdateDisputeIssueBaseDto[]
  >();

  displayedColumns: string[] = ["issue", "description", "actions"];

  private subscriptions = new Subscription();

  constructor(private dialog: MatDialog) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addIssue() {
    const dialogRef = this.dialog.open(AddEditIssueComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        issue: null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.issues = [...this.issues, { ...result }];
        this.issuesChange.emit(this.issues);
      }
    });
  }

  editIssue(issue: DisputeIssueBaseDto) {
    const dialogRef = this.dialog.open(AddEditIssueComponent, {
      width: "1100px",
      data: {
        disputeCase: this.disputeCase,
        issue: { ...issue },
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (!result.id) {
          // Editing a newly created issue (no id): match by reference
          const idx = this.issues.indexOf(issue);
          if (idx !== -1) {
            this.issues = this.issues.map((p, i) =>
              i === idx ? { ...p, ...result } : p
            );
          }
        } else {
          // Editing an existing issue (with id): match by id
          this.issues = this.issues.map((p) =>
            p.id && result.id && p.id === result.id ? { ...p, ...result } : p
          );
        }
        this.issuesChange.emit(this.issues);
      }
    });
  }
}
